export enum AttachmentType {
  PRAKTIKUMSNACHWEIS = "PRAKTIKUMSNACHWEIS",
  SONDERFALLNACHWEIS = "SONDERFALLNACHWEIS",
  BEZUGSNACHWEIS = "BEZUGSNACHWEIS",
  BESTAETIGUNGSBESCHEID = "BESTAETIGUNGSBESCHEID",
  ABLEHNUNGSBESCHEID = "ABLEHNUNGSBESCHEID",
  ANHOERUNGSBESCHEID = "ANHOERUNGSBESCHEID",
  AENDERUNGSBESCHEID = "AENDERUNGSBESCHEID",
  KUENDIGUNGSBESCHEID = "KUENDIGUNGSBESCHEID",
  OTHER = "OTHER"

}

export function getSelectableAttachmentTypes(): AttachmentType[] {
  return Object.values(AttachmentType).filter((type) => {
    return type !== AttachmentType.BESTAETIGUNGSBESCHEID
      && type !== AttachmentType.ABLEHNUNGSBESCHEID
      && type !== AttachmentType.ANHOERUNGSBESCHEID
      && type !== AttachmentType.AENDERUNGSBESCHEID
      && type !== AttachmentType.KUENDIGUNGSBESCHEID;
  });
}

